// ImpersonationBanner — persistent visual reminder while a session-only
// "view as" preview is active. See ImpersonationContext for the
// security model.

import { Eye, X } from 'lucide-react';
import { useImpersonationOptional } from '@/contexts/ImpersonationContext';
import { Button } from '@/components/ui/button';

export function ImpersonationBanner() {
  const imp = useImpersonationOptional();
  if (!imp?.viewAsUserId) return null;
  return (
    <div
      role="alert"
      className="bg-amber-500/15 border-b border-amber-500/40 text-amber-900 dark:text-amber-200 text-xs px-4 py-1.5 flex items-center justify-between gap-3"
    >
      <div className="flex items-center gap-2">
        <Eye className="w-3.5 h-3.5" />
        <span>
          <strong>Impersonation preview</strong> — visning som{' '}
          <span className="font-mono">{imp.label ?? imp.viewAsUserId}</span>.
          Inga writes utförs som denna user — RLS gäller fortfarande för din
          admin-session.
        </span>
      </div>
      <Button
        size="sm"
        variant="ghost"
        className="h-6 text-xs"
        onClick={() => void imp.stop()}
      >
        <X className="w-3.5 h-3.5 mr-1" /> Avsluta
      </Button>
    </div>
  );
}
